import React from "react";
import { NavLink, Link } from "react-router-dom";
import { WHATSAPP_URL, LOGO_SRC } from "@/lib/brand";
import SaveNumberLink from "@/components/SaveNumberLink";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/story", label: "Story" },
  { to: "/farm", label: "The Farm" },
  { to: "/stay", label: "Stay" },
  { to: "/dining", label: "Dining" },
  { to: "/experiences", label: "Experiences" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  return (
    <header
      data-testid="site-nav"
      className="nav-blur fixed top-0 left-0 right-0 z-50 hair-b-light"
      style={{ color: "var(--bamboo-cream)" }}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 h-[64px] md:h-[74px]">
        <Link
          to="/"
          data-testid="nav-wordmark"
          className="link-fade flex items-center"
          aria-label="FarmStory — home"
        >
          <img
            src={LOGO_SRC}
            alt="FarmStory"
            className="h-9 md:h-11 w-auto"
            style={{ objectFit: "contain" }}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="label-track link-fade"
              style={({ isActive }) => ({
                color: isActive ? "var(--sundari-gold)" : "rgba(242,233,212,0.82)",
              })}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            data-testid="nav-cta-whatsapp"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-pill hidden sm:inline-flex"
          >
            <span>Message on WhatsApp</span>
          </a>
          <SaveNumberLink
            tone="light"
            testId="nav-save-number"
            className="hidden md:inline-block"
          />
          <button
            aria-label="Menu"
            data-testid="nav-mobile-toggle"
            className="lg:hidden label-track"
            onClick={() => setOpen((v) => !v)}
            style={{ color: "var(--bamboo-cream)" }}
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden hair-t-light" data-testid="nav-mobile-panel">
          <div className="px-6 py-6 flex flex-col gap-5" style={{ background: "rgba(26,42,30,0.96)" }}>
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="label-track link-fade"
                style={{ color: "var(--bamboo-cream)" }}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-pill self-start"
              data-testid="nav-mobile-cta"
            >
              Message on WhatsApp
            </a>
            <SaveNumberLink tone="light" testId="nav-mobile-save-number" />
          </div>
        </div>
      )}
    </header>
  );
}
